import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Paper from '@material-ui/core/Paper';
import { scroller } from 'react-scroll';
import isEmpty from 'lodash/isEmpty';
import * as actionCreators from 'actions/conversations';
import { list as tagsList } from 'modules/tags/redux/selectors';
import { fetchTagsRequest } from 'modules/tags/redux/actionCreators';
import { userData } from 'selectors/user';
import Main from 'components/templates/Main';
import ConversationsList from '../components/List';
import ConversationsFilters from '../components/ListFilters';

const List = () => {
  const dispatch = useDispatch();
  const { isFetching, data, filter, offset, totalRecords } = useSelector(
    (state) => state.conversations,
  );
  const currentUser = useSelector(userData);
  const previousConversationId = useSelector((state) => state.conversation.id);
  const tags = useSelector(tagsList);

  const fetchMoreData = () => {
    if (!isFetching) {
      dispatch(actionCreators.fetchConversationsRequest());
    }
  };

  React.useEffect(() => {
    if (!isFetching) {
      dispatch(actionCreators.fetchConversationsRequest());
    }

    dispatch(fetchTagsRequest());

    return () => {
      dispatch(actionCreators.clearConversations());
    };
  }, []);

  React.useEffect(() => {
    if (!isEmpty(data) && !isFetching && previousConversationId) {
      if (!data.find((c) => c.id === previousConversationId)) {
        return fetchMoreData();
      }

      setTimeout(() => {
        scroller.scrollTo('previousConversationId', {
          duration: 800,
          delay: 0,
          smooth: 'easeInOutQuart',
          offset: -64,
        });
      }, 500);
    }
  }, [data, isFetching]); // eslint-disable-line

  const changeFilter = (event) => {
    const { value } = event.target;

    if (value.some((v) => !v)) {
      dispatch(actionCreators.setConversationsFilter({ filter: [] }));
    } else {
      dispatch(actionCreators.setConversationsFilter({ filter: value }));
    }

    return fetchMoreData();
  };

  const isLoading = isFetching || isEmpty(currentUser);

  return (
    <Main title={<FormattedMessage id="conversations.Messages" defaultMessage="Messages" />}>
      <Paper>
        <ConversationsFilters changeFilter={changeFilter} filter={filter} tags={tags} />
        <ConversationsList
          totalRecords={totalRecords}
          offset={offset}
          fetchMoreData={fetchMoreData}
          data={data}
          currentUser={currentUser}
          previousConversationId={previousConversationId}
          isLoading={isLoading}
        />
      </Paper>
    </Main>
  );
};

export default List;
